import { OverlayRef } from '@angular/cdk/overlay';

export class OverlayModalRef {
  constructor(private overlayRef: OverlayRef) {}

  close(): void {
    this.overlayRef.dispose();
  }
}
